import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/life-at-kingston/layoutProps';

import image from './wellbeing@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="student-well-being">
    <h1>學生的身心健康</h1>
    <p>
      作為一間開辦國際文憑小學課程的學校，我們深信每一位孩子都是獨立的個體，並在平衡的生活中有所得益。學校旨在讓學生透過參與探索課程及課外活動，讓他們建立多角度的思維及培養紀律性，在成長的過程中有所得着。
    </p>
    <p>
      透過我們的探索課程、教師的教導、家長及學生的支持，我們見證了學生在不同領域上均有貢獻：亞洲黑熊及猩猩的棲息地得以持續保存、位於柬埔寨的Jong
      Ra School的建設得以完善。學生能參與不同運動：體操、馬術、曲棍球、足球、欖球及越野賽跑；我們亦在Battle of the
      Books比賽中獲勝、學生作品被摘錄在公開寫作比賽選集中、學生進行有關學校環保的匯報、參與清潔沙灘活動、學習鍛煉集中力及注意力、出版校報、打理學校園圃、回收玻璃、紙張及塑膠活動，參與音樂表演及到外地考察世界各地文化。對於一所小型的學校而言，我們的學生實在獲益良多！
    </p>
    <p>
      學生的意見是我們校園非常重視的一環。每一位學生均可透過製作小型的小學項目學習成果展、表演活動、慈善籌款活動、學會活動、課室活動及學生會舉辦的活動來表達他們對學校的意見。多年來，京斯敦國際學校學生會負責舉辦很多不同的活動，學生會由始至終均獨立負責整個活動的運作，讓所有家長、教師及學生均可參與其中。
    </p>
    <img src={image} alt="Student well-being" />
  </ContentLayout>
);
